<template>
  <div class="page-container">
    <div id="searchArea">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList(1)">
        <div class="clearfix">
          <div class="fl pb10">
            <el-button type="primary" :disabled="addBtnLoading" @click="addOrUpdateHandle()">Add Supplier</el-button>
          </div>
          <div class="fr">
            <el-form-item>
              <el-input v-model="dataForm.keyword" clearable placeholder="Abbreviation / Company Name" class="wd300"></el-input>
            </el-form-item>
            <el-form-item>
              <el-select v-model="dataForm.country" filterable clearable placeholder="Country">
                <el-option v-for="item in countryList" :key="item.value" :label="item.title" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" type="primary" plain v-debounce @click="getDataList(1)">Search</el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <div>
      <el-table
        max-height="680"
        :data="dataList"
        v-loading="dataListLoading"
        @sort-change="tableSortChange"
        :default-sort="{ prop: 'createTime', order: 'descending' }"
        style="width: 100%"
      >
        <el-table-column prop="abbr" label="Abbreviation" align="center" width="120"></el-table-column>
        <el-table-column prop="companyName" label="Company Name" align="center" width="250"></el-table-column>
        <el-table-column prop="country" label="Country" align="center" min-width="150"></el-table-column>
        <el-table-column prop="registrationNo" label="Reg No." align="center" min-width="130"></el-table-column>
        <el-table-column label="Tax Types" align="center" min-width="260">
          <template slot-scope="scope">
            <el-tag size="mini" v-for="(item, index) in scope.row.taxInfos" :key="`taxInfos-${scope.row.id}-${index}-${item.taxType}`" class="ml2 mr2">
              {{ item.taxType }} {{ item.taxRate | percentage }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="invoiceNumberPrefix" label="Invoice Prefix" align="center" min-width="130"></el-table-column>
        <el-table-column label="Create Time" prop="createTime" align="center" width="160" sortable="custom" />
        <el-table-column label="Action" align="center" width="120" fixed="right">
          <template slot-scope="scope">
            <!-- 修改 -->
            <el-button type="text" class="fwb" @click="addOrUpdateHandle(scope.row)">Edit</el-button>
            <!-- 删除 -->
            <el-button type="text" class="fwb" @click="deleteHandle(scope.row)">Delete</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <pagination
      :current="current"
      :pageSize="pageSize"
      :totalCount="totalCount"
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
    ></pagination>

    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update
      ref="addOrUpdate"
      :supplierList="supplierList"
      :invoiceTemplateList="invoiceTemplateList"
      @refreshDataList="refreshDataList"
    ></add-or-update>
  </div>
</template>

<script>
import AddOrUpdate from "./modal/AddOrUpdate";
import Pagination from "@/components/Pagination";
import paginationMixin from "@/mixins/paginationMixin";
import filtersMixin from "@/mixins/filtersMixin";
import tableMixin from "@/mixins/tableMixin";
import { mapState } from "vuex";
export default {
  mixins: [paginationMixin, filtersMixin, tableMixin],
  components: {
    AddOrUpdate,
    Pagination,
  },
  data() {
    return {
      dataForm: {
        keyword: "",
        country: "",
        "orders[0].asc": false,
        "orders[0].column": "id",
      },
      dataList: [],
      addBtnLoading: false,
      dataListLoading: false,
      supplierList: [],
      invoiceTemplateList: [],
    };
  },
  computed: {
    ...mapState("constant", ["countryList"]),
  },
  methods: {
    // 获取供应商列表
    getSupplierList() {
      return new Promise((resolve, reject) => {
        this.$http
          .get("/admin/supplier")
          .then(res => {
            this.supplierList = res.data || [];
            resolve();
          })
          .catch(err => {
            reject();
          });
      });
    },
    // 获取发票模板列表
    getInvoiceTemplateList() {
      return new Promise((resolve, reject) => {
        this.$http
          .get("/admin/invoiceTemplate")
          .then(res => {
            const resData = res.data || [];
            // 只保留发票模板，排除退款发票(Credit Invoice)模板
            this.invoiceTemplateList = resData.filter(item => item.invoiceType == 1);
            resolve();
          })
          .catch(err => {
            reject();
          });
      });
    },
    // 获取数据分页
    async getDataList(current) {
      this.dataListLoading = true;
      if (current) {
        this.current = current;
      }
      const params = {
        current: this.current,
        size: this.pageSize,
        ...this.dataForm,
      };
      const { code, data } = await this.$http.get("/admin/supplier/page", {
        params,
      });
      if (code === 200) {
        this.dataList = data.records;
        this.totalCount = data.total;
      } else {
        this.dataList = [];
        this.totalCount = 0;
      }
      this.dataListLoading = false;
    },
    // 新增 / 修改
    addOrUpdateHandle(row) {
      this.$refs.addOrUpdate.init(row);
    },
    // 删除
    async deleteHandle(row) {
      await this.$confirm(`Delete this supplier. Continue?`, "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      });
      const { code, msg } = await this.$http.post(
        `/admin/supplier/batchDelete`,
        {},
        {
          params: {
            "ids[]": row.id,
          },
        },
      );
      if (code === 200) {
        this.$message({
          message: "success",
          type: "success",
          duration: 1500,
          onClose: () => {
            // mixins
            this.singleDataDelete();
            this.getSupplierList();
            this.getDataList();
          },
        });
      } else {
        this.$message.error(msg);
      }
    },
    // 弹窗组件触发更新
    refreshDataList() {
      this.getSupplierList();
      this.getDataList();
    },
  },
  async activated() {
    try {
      this.addBtnLoading = true;
      this.dataListLoading = true;
      await this.getSupplierList();
      await this.getInvoiceTemplateList();
    } catch (error) {
    } finally {
      this.getDataList();
      this.addBtnLoading = false;
    }
  },
};
</script>
